import { Input, Label, Stack, Typography } from "@altimateai/lego";
import { IconCircleCheck, IconX } from "@tabler/icons-react";
import { useMemo } from "react";
import { classifyIdentifier } from "./servicePrincipalUtils";

interface Props {
  value: string;
  onChange: (value: string) => void;
  prefixes: string[];
  regexes: string[];
}

const ServicePrincipalTestResult = ({ value, onChange, prefixes, regexes }: Props) => {
  const result = useMemo(
    () => (value.trim() ? classifyIdentifier(value.trim(), prefixes, regexes) : null),
    [value, prefixes, regexes]
  );

  return (
    <Stack direction="column" gap="xs">
      <Label htmlFor="sp-test-identifier">Test against an identifier</Label>
      <Input
        id="sp-test-identifier"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="e.g. svc_etl_runner"
      />
      {result && (
        <Stack
          direction="row"
          align="center"
          gap="xs"
          className={result.isServicePrincipal ? "al-text-green-600" : "al-text-muted-foreground"}
        >
          {result.isServicePrincipal ? <IconCircleCheck size={16} /> : <IconX size={16} />}
          <Typography size="sm">
            {result.isServicePrincipal ? "Service Principal" : "User"} — {result.reason}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default ServicePrincipalTestResult;
